// Newsletter issue registry.
// Issue web content is served as a static HTML file (installed verbatim per Greg's spec).
// The React wrapper only adds the OGO shell (sticky nav, disclaimer, download buttons).

export const NEWSLETTER_META = {
  brand: "OGO Weekly Notary Brief",
  amazonEssentialsUrl: "https://amzn.to/4dtUVeM",
  amazonEssentialsLabel: "Shop Notary Essentials",
  affiliateDisclosure:
    "Affiliate Disclosure: As an Amazon Associate, OldGuyOutside, LLC may earn from qualifying purchases made through eligible links, at no additional cost to you.",
  permanentDisclaimer:
    "Disclaimer: This publication is provided for general educational, informational, and entertainment purposes only. It is not legal, tax, accounting, financial, medical, healthcare, or other professional advice. Information may change and may not apply to every person, transaction, jurisdiction, or circumstance. Consult the appropriate government authority and a qualified licensed professional before acting. No professional-client or provider-patient relationship is created.",
};

export const NEWSLETTER_ISSUES = [
  {
    slug: "issue-01",
    number: "01",
    publication: "September 2026",
    publishedAt: "2026-09-11",
    verifiedThrough: "September 2026",
    title: "OGO Weekly Notary Brief — Issue 01",
    stateSpotlight: "Florida",
    serviceFocus: "Hospital and Senior Notarization",
    clientGrowth: "Marketing to Elder-Law Professionals",
    businessDesk: "Business Expense Documentation and Recordkeeping",
    cover: "/img/newsletter-issue-01-cover.png",
    coverAlt:
      "OGO Weekly Notary Brief Issue 01 cover — rolled newsletter, brass notary seal, fountain pen, and leather journal on a walnut desk",
    pdfUrl: "/downloads/ogo-notary-brief-issue-01.pdf",
    webUrl: "/newsletter/issue-01.html",
    sections: [
      {
        kicker: "National Notary Brief",
        headline: "Apostille Work Is Changing Beyond State Lines",
        excerpt:
          "Cross-jurisdictional apostille demand is shifting how mobile notaries and signing agents route international document work. What every professional should watch this quarter.",
      },
      {
        kicker: "State Spotlight · Florida",
        headline: "Florida Notaries Should Watch RON Identity Rules",
        excerpt:
          "Florida's remote-online-notarization identity-proofing requirements are drawing renewed regulator attention. What the current statute says — and what is only proposed.",
      },
      {
        kicker: "Service Focus · Hospital & Senior Notarization",
        headline: "The Appointment Begins Before the Stamp",
        excerpt:
          "A field playbook for bedside, hospital, and senior-community signings — the pre-appointment steps that keep signings dignified, safe, and compliant.",
      },
      {
        kicker: "Client Growth · Elder-Law Professionals",
        headline: "Market Reliability Instead of Selling a Stamp",
        excerpt:
          "Ethical, practical ways to become the go-to notary for elder-law attorneys, probate offices, and estate planners in your county.",
      },
      {
        kicker: "The Notary Business Desk · Expense Documentation",
        headline: "A Deduction Begins With a Business Record",
        excerpt:
          "Practical recordkeeping habits that keep expense documentation defensible — mileage, supplies, tech, training, and the small business systems around them.",
      },
    ],
    isPublic: true,
    isPublished: true,
  },
];

export function getIssueBySlug(slug) {
  return NEWSLETTER_ISSUES.find((i) => i.slug === slug) || null;
}

export const CURRENT_ISSUE = NEWSLETTER_ISSUES[0];
